import * as React from "react";

import * as Scroll from "react-scroll";

const ScrollLink = Scroll.Link;

/*===========================================================================
  Detail
/*======================================================================== */
interface DetailProps {
    actions: React.ReactNode
    children: React.ReactNode
    id: string
    footer: React.ReactNode
    meta: any
    nav: any[]
	ribbon: React.ReactNode
    subtitle: string  | React.ReactNode
    summary: React.ReactNode
    title: string
}

export const Detail = props => {
    const classes = ["c-detail"];

    return (
        <section className={classes.join(" ")} id={props.id}>
            <section className="c-detail__main">
                <div className="c-detail__header">
                    {props.nav && (
                        <nav className="c-detail__nav">
                            {props.nav.map(section => (
                                <ScrollLink
                                    to={section.replace(/\s+/, "-")}
                                    className="c-link no-underline"
                                    activeClass="is-active"
                                    key={section}
                                    smooth={true}
                                    offset={-100}
                                    duration={500}>
                                    {section}
                                </ScrollLink>
                            ))}
                        </nav>
                    )}
                </div>
                {props.ribbon}
                <div className="c-detail__body">
                    <h1 className="c-detail__title" data-cy="jobDetail-jobTitle-h1">{props.title}</h1>
                    {props.subtitle && <div className="c-detail__subtitle">{props.subtitle}</div>}
                    {props.meta &&
                        props.meta.listItems && (
                            <ul className="c-detail__meta">
                                {props.meta.listItems.map((meta, index) => (
                                    <li className={props.meta.listItemClass} key={index}>
                                        {meta}
                                    </li>
                                ))}
                            </ul>
                        )}
                    {props.actions}
                    {props.children}
                </div>
            </section>
            {props.summary && <section className="c-detail__sidebar">{props.summary}</section>}
            {props.footer}
            {/* TODO: Need to investigate if footer is really used.
            I can not see where it ever appears on screen*/}
        </section>
    );
}

export default Detail;
